import React, {useState} from 'react';
import close from "../../images/Close.svg";
import Main from "./Main";
import DataLoader from "./DataLoader";
export default function DataConnectorVerification(props) {
    const [page , setPage] = useState('main')

    const modalStyle = {
        width: 903,
        zIndex: 999,
        padding: '16px 24px 24px',
        borderRadius: 20,
    }

    return (
        <>
            <div style={{zIndex: 999}} className="modal-parent d-flex justify-content-center align-items-center">
                <div className="modal-back"></div>
                <div style={modalStyle} className="modal fade-in-top wizard d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                            {/*{page !== 'main' &&*/}
                            {/*    <img src={backImg} onClick={() => setPage('main')} className="mr-32" alt="back"/>*/}
                            {/*}*/}
                            <h3>
                                {page === 'main' && props.readOnly ? 'Data Connector' : 'Data Connector Verification'}
                                {page === 'data-loader' && 'Data Loader'}
                            </h3>
                        </div>
                        <img onClick={() => props.close()} className="pointer" src={close} alt="close"/>
                    </div>
                    <div className={page === 'main' ? '' : 'd-none'}>
                        <Main name={props.name} readOnly={props.readOnly} goNext={()=>setPage('data-loader')} getData={props.getData} uid={props.uid} close={() => props.close()}/>
                    </div>
                    {page === 'data-loader' && <DataLoader name={props.name} uid={props.uid} getData={props.getData} />}
                </div>
            </div>

        </>
    );
}
